import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";

const TableComponent = ({ rows, columns, actions, onActionClick }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((col, index) => (
              <TableCell
                key={index}
                sx={{
                  backgroundColor: "#2c2d2d",
                  color: "#fff",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {col.header}
              </TableCell>
            ))}
            {actions && (
              <TableCell
                sx={{
                  backgroundColor: "#2c2d2d",
                  color: "#fff",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                Actions
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow
              key={row.id}
              sx={{
                backgroundColor: rowIndex % 2 === 0 ? "#ffffff" : "#e0e0e0", // Solid grey for odd rows
              }}
            >
              {columns.map((col, index) => (
                <TableCell key={index} sx={{ textAlign: "center" }}>
                  {col.render ? col.render(row) : row[col.field]}
                </TableCell>
              ))}
              {actions && (
                <TableCell sx={{ textAlign: "center" }}>
                  {actions.map((action, index) => (
                    <Tooltip key={index} title={action.tooltip || ""}>
                      <IconButton onClick={() => onActionClick(row, action)}>
                        {action.icon}
                      </IconButton>
                    </Tooltip>
                  ))}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableComponent;